// extracted by mini-css-extract-plugin
export default {"base":"vp_e1Xn6","number":"vp_QWSJx","meter":"vp_R2AFi","wrapper":"vp_zJ4Vx","text":"vp_bDbVD","arrow":"vp_DmmTv","preview":"vp_Vyw2O"};